import React, { Component } from 'react';
import {
    Container,
    Typography,
    Box,
} from '@material-ui/core';
import BreadcrumbLayout from "../../shared/components/common/breadcrumbLayout";
import { WorkshopEquipmentService } from './service';
import EquipamentDetailsInfoContainer from "../../shared/components/equipamentDetails/equipamentDetailsInfoContainer";
import ImageModal from "../../shared/components/common/imageModal";
import EquipamentDetailsImagesContainer
    from "../../shared/components/equipamentDetails/equipamentDetailsImagesContainer";
import EquipamentDetailsHistoryContainer
    from "../../shared/components/equipamentDetails/equipamentDetailsHistoryContainer";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";

const styles = (theme) => ({
    container: {
        backgroundColor: "#FFFFFF",
        color: "#000000"
    },
    content: {
        margin: "40px auto",
        padding: "20px",
        maxWidth: "800px",
        backgroundColor: "#FFFFFF",
    },
    title: {
        fontWeight: "400",
        fontSize: "calc(1.3rem + .6vw)",
        marginBottom: "0.5rem",
        color: "#222222",
    },
    sectionTitle: {
        fontWeight: "500",
        marginTop: "2rem",
        marginBottom: "0.5rem",
        color: "#222222",
        borderBottom: "1px solid #CCCCCC",
        paddingBottom: "5px",
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200
    },
    errorContainer: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: '#d32f2f'
    }
});

class WorkshopEquipmentDetailsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            equipment: null,
            loading: true,
            error: null,
            selectedImage: null,
            modalOpen: false,
        };
    }

    componentDidMount() {
        this.fetchEquipmentData();
    }

    fetchEquipmentData = async () => {
        try {
            const id = this.props.match.params.id || sessionStorage.getItem("CORE_EquipamentoSelecionado") || 1;

            if (!id) {
                const { currentLanguage } = this.props;
                this.setState({ error: currentLanguage.bepiService.workshop.workshop_equip_details_id_not_found, loading: false });
                return;
            }

            const data = await WorkshopEquipmentService.getEquipmentDetails(id);
            this.setState({
                equipment: data,
                loading: false,
                error: null
            });
        } catch (error) {
            console.error('Erro ao buscar dados do equipamento:', error);
            const { currentLanguage } = this.props;
            this.setState({
                error: currentLanguage.bepiService.workshop.workshop_equip_details_load_error,
                loading: false
            });
        }
    }

    handleImageClick = (imageUrl) => {
        this.setState({ selectedImage: imageUrl, modalOpen: true });
    }

    handleCloseModal = () => {
        this.setState({ modalOpen: false, selectedImage: null });
    }

    handleDownloadReport = async (fileName) => {
        try {
            await WorkshopEquipmentService.downloadReport(fileName);
        } catch (error) {
            console.error('Erro ao fazer download:', error);
            const { currentLanguage } = this.props;
            alert(currentLanguage.bepiService.workshop.workshop_equip_details_download_error);
        }
    }

    formatarData = WorkshopEquipmentService.formatarData;
    formatarDataHora = WorkshopEquipmentService.formatarDataHora;
    isRevisaoPendente = WorkshopEquipmentService.isRevisaoPendente;

    getBreadcrumbItems = () => {
        const { currentLanguage } = this.props;
        return [
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_home, path: '/bepi/workshop' },
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_equipments, path: '/bepi/workshop/equipaments' },
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_details },
        ];
    }

    renderLoading = () => (
        <Box className={this.props.classes.loadingContainer}>
            <Typography>{this.props.currentLanguage.bepiService.workshop.workshop_equip_details_loading_msg}</Typography>
        </Box>
    );
    renderLoading = () => {
        const { classes, currentLanguage } = this.props;
        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.shared.shared_breadcrumb_details}
                breadcrumbItems={this.getBreadcrumbItems()}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Box className={classes.container}>
                    <Container className={classes.content}>
                        <Typography>{currentLanguage.bepiService.workshop.workshop_equip_details_loading_short_msg}</Typography>
                    </Container>
                </Box>
            </BreadcrumbLayout>
        );
    }

    renderError = () => (
        <Box className={this.props.classes.errorContainer}>
            <Typography variant="h6" color="error">
                {this.state.error}
            </Typography>
            <button
                onClick={this.fetchEquipmentData}
                style={{
                    marginTop: 16,
                    padding: '8px 16px',
                    backgroundColor: '#1976d2',
                    color: 'white',
                    border: 'none',
                    borderRadius: 4,
                    cursor: 'pointer'
                }}
            >
                {this.props.currentLanguage.bepiService.workshop.workshop_equip_details_try_again_btn}
            </button>
        </Box>
    );

    renderContent = () => {
        const { classes, currentLanguage } = this.props;
        const { equipment, selectedImage, modalOpen } = this.state;

        if (!equipment) {
            return (
                <Typography className={classes.noDataText}>
                    {currentLanguage.bepiService.workshop.workshop_equip_details_no_data_msg}
                </Typography>
            );
        }
    }

    render() {
        const { classes, currentLanguage } = this.props;
        const { equipment, loading, error, selectedImage, modalOpen } = this.state;

        if (!equipment && !loading && !error) {
            return (
                <Typography className={classes.noDataText}>
                    {currentLanguage.bepiService.workshop.workshop_equip_details_no_data_msg}
                </Typography>
            );
        }

        if (loading) return this.renderLoading();
        if (error) return this.renderError(error);
        if (!equipment) return this.renderNotFound();

        const { equipamento, fotos, laudos } = equipment;

        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.shared.shared_breadcrumb_details}
                breadcrumbItems={this.getBreadcrumbItems()}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Box className={classes.container}>
                    <Container className={classes.content}>
                        <Typography className={classes.title}>
                            {currentLanguage.bepiService.workshop.workshop_equip_details_item_data_title}
                        </Typography>
                        <EquipamentDetailsInfoContainer equipment={equipamento} currentLanguage={currentLanguage} />

                        <Typography variant="h5" className={classes.sectionTitle}>
                            {currentLanguage.bepiService.workshop.workshop_equip_details_last_photos_title}
                        </Typography>
                        <EquipamentDetailsImagesContainer
                            photos={fotos}
                            onPhotoClick={this.handleImageClick}
                            currentLanguage={currentLanguage}
                        />

                        <Typography variant="h5" className={classes.sectionTitle}>
                            {currentLanguage.bepiService.workshop.workshop_equip_details_history_title}
                        </Typography>
                        <EquipamentDetailsHistoryContainer history={laudos} currentLanguage={currentLanguage} />

                        <ImageModal
                            isOpen={modalOpen}
                            imageUrl={selectedImage}
                            onClose={this.handleCloseModal}
                            currentLanguage={currentLanguage}
                        />
                    </Container>
                </Box>
            </BreadcrumbLayout>
        );
    }
}

export default withRouter(withStyles(styles)(WorkshopEquipmentDetailsPage));

